import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-network-navigation',
  templateUrl: './network-navigation.component.html',
  styleUrls: ['./network-navigation.component.scss']
})

export class NetworkNavigationComponent implements OnInit {

  @Input() level1Length: Number;
  @Input() level2Length: Number;
  @Output() showLevel = new EventEmitter<boolean>();

  @Input() defaultLevel = true;
  @Input() isPharmacy;

  constructor() { }

  ngOnInit() {
  }

  changeLevel(event) {
    if (this.defaultLevel !== event) {
      this.defaultLevel = event;
      this.showLevel.emit(event);
    }
  }

}
